export class SteamValidators {
  static get tradeLinkPattern(): RegExp {
    return /^(http|https):\/\/steamcommunity.com\/tradeoffer\/new\/\?partner=([0-9]+)&token=([a-zA-Z0-9_]+)/;
  }
}
